import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./styles/theme";
import "./i18n";
import { AuthProvider } from "./context/AuthContext";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { cleanupOldCacheKeys } from "./storage/cacheManager";

cleanupOldCacheKeys().catch(console.error);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <App />
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>,
);

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    console.log("Найдена новая версия приложения");
  },
  onSuccess: () => {
    console.log("Service Worker успешно зарегистрирован");
  },
});
